import React from 'react';
import classnames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import { pushParams, resetParams } from 'dpl/actions/query_params';
import { FILTER_GENDER, RESULTS_TYPE } from 'dpl/constants/query_params';
import InputCard from 'dpl/common/design_system/InputCard';
import { RESULTS_TYPES } from 'dpl/puppy_search_results/utils/constants';
import { isLessThanBreakpoint } from 'dpl/util/grid';

const IS_LT_MD = isLessThanBreakpoint('md');

export default function GenderFilter() {
  const queryParams = useSelector(state => state.queryParams);
  const { genderOptions } = useSelector(({ server }) => server);
  const dispatch = useDispatch();

  function updateFilterValue(value) {
    dispatch(
      pushParams(
        { [RESULTS_TYPE]: RESULTS_TYPES.PUPPIES, [FILTER_GENDER]: value },
        { hash: true }
      )
    );
  }

  function handleFilterChange(e) {
    const { value } = e.target;
    const paramValue = queryParams[FILTER_GENDER];
    const genderFilterValues = genderOptions.map(go => go.value);
    const oppositeValue = genderFilterValues.find(v => v !== value) || '';

    if (paramValue === 'any') {
      updateFilterValue(oppositeValue);
    } else if (paramValue === value) {
      dispatch(resetParams(FILTER_GENDER, { hash: true }));
    } else if (paramValue === oppositeValue) {
      updateFilterValue('any');
    } else {
      updateFilterValue(value);
    }
  }

  function isSelected(opt) {
    const paramValue = queryParams[FILTER_GENDER];
    if (!paramValue) {
      return false;
    }
    if (paramValue === 'any' || opt.value === paramValue) {
      return true;
    }
    return false;
  }

  return (
    <>
      <h4 className="font-20 lh-title mb6">Gender</h4>
      <div
        className={classnames('SearchResultFiltersGenderFilter row', {
          'slim-gutters': IS_LT_MD
        })}
      >
        {genderOptions.map(opt => (
          <div
            key={opt.value}
            className="SearchResultFiltersGenderFilter__option col-6"
          >
            <InputCard
              className={classnames('ba ph4 pv4', {
                'b--default': !isSelected(opt),
                'b--stone-700': isSelected(opt)
              })}
              type="checkbox"
              icon={{
                className: 'bg-gray-200 secondary ph2 pv2 mb3',
                name: opt.value,
                size: '20'
              }}
              inputProps={{
                name: `${FILTER_GENDER}_${opt.value}`,
                value: opt.value,
                onChange: handleFilterChange
              }}
            >
              <div className="font-16 lh-1 secondary mt6">{opt.title}</div>
            </InputCard>
          </div>
        ))}
      </div>
    </>
  );
}
